import React, { useEffect, useState, useRef } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { checkUsername } from '../../services/apiService';
import { validateEmail } from '../../utils';
import useDebounce from '../../hooks/useDebounce';

import './form.scss';
import ButtonSpiner from '../buttonSpinner';

const RegoForm = ({ isOpen, submitForm, setIsOpen, isRegoLoading, setIsRegoLoading }) => {
  const [debounce] = useDebounce();
  const {
    formState: { errors, isValid, isDirty },
    handleSubmit,
    register,
    reset,
    watch,
  } = useForm({
    mode: 'onChange',
  });
  const passwordValue = watch('password', '');

  const onSubmit = handleSubmit(data => {
    submitForm(data);
    reset();
    setIsOpen(false);
  });

  return (
    <Modal show={isOpen}>
      <Form onSubmit={onSubmit} className="cdh-form rego-form">
        <Modal.Header>
          <Modal.Title>Registration</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Username</Form.Label>
            <Form.Control
              placeholder="username"
              {...register('username', {
                validate: async value => {
                  return new Promise(resolve => {
                    if (/[^a-z0-9_-]/gi.test(value)) {
                      resolve('Username can only have alphanumeric characters');
                    }
                    debounce(async () => {
                      const { doesExist } = await checkUsername(value);
                      resolve(!doesExist || 'Username exists');
                    });
                  });
                },
                required: 'Username is required',
              })}
            />
            {errors.username && errors.username.message && (
              <div className="invalid-feedback">{errors.username.message}</div>
            )}
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Password</Form.Label>
            <Form.Control
              name="password"
              type="password"
              placeholder="password"
              {...register('password', {
                validate: value => {
                  return value.trim().length > 3 || 'Password must have at least 4 characters';
                },
                required: 'Password is required',
              })}
            />
            {errors.password && errors.password.message && (
              <div className="invalid-feedback">{errors.password.message}</div>
            )}
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Repeat password</Form.Label>
            <Form.Control
              name="password2"
              type="password"
              placeholder="repeat password"
              {...register('password2', {
                validate: value => {
                  return passwordValue.trim() === value.trim() || 'The passwords do not match';
                },
                required: 'Password is required',
              })}
            />
            {errors.password2 && errors.password2.message && (
              <div className="invalid-feedback">{errors.password2.message}</div>
            )}
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              placeholder="email"
              {...register('email', {
                validate: value => {
                  return validateEmail(value) || 'Email is invalid';
                },
                required: 'Email is required',
              })}
            />
            {errors.email && errors.email.message && (
              <div className="invalid-feedback">{errors.email.message}</div>
            )}
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline"
            className="btn-outline-secondary site-btn"
            onClick={() => {
              reset();
              setIsOpen(false);
            }}
          >
            Cancel
          </Button>
          <Button
            disabled={!isValid && isDirty}
            variant="primary"
            type="submit"
            className="site-btn"
          >
            {isRegoLoading ? (
              <>
                <ButtonSpiner />
                {'Registering...'}
              </>
            ) : (
              'Register'
            )}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default RegoForm;
